// i18next-extract-mark-ns-start Step1
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Cloth } from '../../types/products-types';
import { DesktopText2, tabletThresholdPixels } from '../home/v4/styledComponents';
import iconChecked from '../../assets/order/iconChecked.svg';

const ReInsuranceInfosContainer = styled.div<{ vertical: boolean }>`
  display: flex;
  flex-direction: ${({ vertical }) => (vertical ? 'column' : 'row')};
  justify-content: space-between;
  gap: 10px;
  margin: ${({ vertical }) => (vertical ? '20px 0' : '32px 0')};
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 12px 0 20px;
    flex-direction: column;
    display: ${({ vertical }) => (vertical ? 'none' : 'flex')};
  }
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 14px;
  align-items: start;
`;

const Icon = styled.img``;

interface ReInsuranceInfo {
  title: string;
  description: string;
}

interface ReInsuranceInfosProps {
  clothesPackage: Cloth[];
  clothesAtHome: Cloth[];
  isDoubleProcess: boolean;
  vertical: boolean;
}

const getReInsuranceInfos = (
  t: (_key: string) => string,
  clothesPackage: Cloth[],
  clothesAtHome: Cloth[],
  isDoubleProcess: boolean,
): ReInsuranceInfo[] | null => {
  if (isDoubleProcess) {
    return [
      {
        title: t('Qualité garantie'),
        description: t('par nos artisans'),
      },
      {
        title: t('Maroquinerie et cordonnerie'),
        description: t('Envoyez votre colis en atelier'),
      },
      {
        title: t('Vêtements & linge de maison'),
        description: t('Recevez un artisan à domicile'),
      },
      {
        title: t('Délais de 3 à 7 jours'),
        description: t('Après la validation du devis'),
      },
    ];
  }
  if (clothesPackage.length > 0) {
    return [
      {
        title: t('Qualité garantie'),
        description: t("par nos artisans à l'atelier"),
      },
      {
        title: t('Paiement uniquement'),
        description: t('Après validation du devis'),
      },
      {
        title: t('Délais de 7 jours'),
        description: t('après la validation du devis'),
      },
    ];
  }
  if (clothesAtHome.length > 0) {
    return [
      {
        title: t('Qualité garantie'),
        description: t('par nos artisans Tilli'),
      },
      {
        title: t('Validation du devis'),
        description: t('lors du RDV avec votre artisan'),
      },
      {
        title: t('Délais de 3 à 5 jours'),
        description: t('après le RDV'),
      },
    ];
  }
  return null;
};

const ReInsuranceInfos: React.FC<ReInsuranceInfosProps> = ({
  clothesPackage,
  clothesAtHome,
  isDoubleProcess,
  vertical,
}) => {
  const { t } = useTranslation();
  const reInsuranceInfos = getReInsuranceInfos(t, clothesPackage, clothesAtHome, isDoubleProcess);
  if (!vertical) reInsuranceInfos?.slice(0, 2);
  if (!reInsuranceInfos) {
    return null;
  }

  return (
    <ReInsuranceInfosContainer vertical={vertical}>
      {reInsuranceInfos.map((info) => (
        <InfoContainer key={`reinsurance-info-${info.title}`}>
          <Icon src={iconChecked} alt="icon list info" />
          <div>
            <DesktopText2 bold>{info.title}</DesktopText2>
            <DesktopText2>{info.description}</DesktopText2>
          </div>
        </InfoContainer>
      ))}
    </ReInsuranceInfosContainer>
  );
};

export default ReInsuranceInfos;
